import { useNavigate, useParams } from 'react-router-dom';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Text } from '~/components/atomic';
import { useLeaveChatRoomMutation } from '~/features/chatRoom';
import { LeaveChatRoomRequest } from '~/types';
import { PAGE_ROUTE } from '~/constants';
import { useUserStore } from '~/store';
import * as S from '../ClueNoteModal/ClueNoteModal.styled';

export default function GameEndModal() {
  const email = useUserStore((state) => state.email);
  const { id } = useParams();
  const chatroom_id = id || '';
  const navigate = useNavigate();
  // const { getStep, setStep, removeStep } = useMysteryChatStore((state) => ({
  //   getStep: state.getStep,
  //   setStep: state.setStep,
  //   removeStep: state.removeStep,
  // }));

  const { mutate: leaveChatRoomMutate, isPending: isChatPending } =
    useLeaveChatRoomMutation();

  const handleLeaveRoomClick = async () => {
    const requestData: LeaveChatRoomRequest = {
      chatroom_id: chatroom_id || '',
    };

    leaveChatRoomMutate(requestData, {
      onSuccess: ({ status }) => {
        navigate(PAGE_ROUTE.CHAT_LIST);
      },
    });
  };

  return (
    <>
      <S.Container className='Modal'>
        <Inner>
          <ModalCircle>
            <Text
              as={'strong'}
              fontStyle='title.section28_bold'
              color='content_light_1'
            >
              GAME END
            </Text>
            <Desc
              as={'p'}
              fontStyle='text.body14_medium'
              color='content_light_1'
            >
              Did you enjoy the scenario? <br />
              Thank you for playing!
            </Desc>
            <CloseButtonBox onClick={handleLeaveRoomClick}>
              <button>
                <Text
                  as={'span'}
                  fontStyle='title.section18_medium'
                  color='content_dark_1'
                >
                  Leave
                </Text>
              </button>
            </CloseButtonBox>
          </ModalCircle>
        </Inner>
      </S.Container>
      <S.Background onClick={handleLeaveRoomClick} className='background' />
    </>
  );
}

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    position: fixed;
    z-index: ${theme.zIndex.modal};
    top: 50%;
    left: 50%;
    flex-direction: column;
    flex-direction: 8px;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-width: 280px;
    max-width: 360px;
    height: 80%;
    min-height: 180px;
    overflow: hidden;
    transform: translate(-50%, -50%) translate(-0.5px, -0.5px);
    border-radius: 16px;
    will-change: translate;
  `}
`;

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const ModalCircle = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 32px;
    min-width: 300px;
    min-height: 300px;
    border-radius: 50%;
    stroke: ${theme.stroke.stroke_1};
    background: ${theme.backgroundColor.bg_dark_4_alpha};
    box-shadow: 0px 0px 64px 0px rgba(61, 241, 243, 0.3);
    backdrop-filter: blur(20px);
  `}
`;

export const Desc = styled(Text)`
  display: block;
  text-align: center;
`;

export const CloseButtonBox = styled.div`
  ${({ theme }) => css`
    display: block;

    & > button {
      display: block;
      width: 180px;
      height: 44px;
      border-radius: 22px;
      background: ${theme.themeColor.main_1};
    }
  `}
`;
